module.exports = "<button class=\"email-sub__close js-email-sub--close\" data-link-name=\"hide\">\n    <span class=\"email-sub__hidden\">Close</span>\n    <span class=\"email-sub__close-icon\">\n        <%=closeIcon%>\n    </span>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./static/src/javascripts/projects/common/views/ui/close-button.html
// module id = 670
// module chunks = 5